import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d974580"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "audio-player" }
const _hoisted_2 = { class: "audio-player-left" }
const _hoisted_3 = ["id"]

import { IconType } from "@/types/icons";
import Icon from "@/components/icons/Icon/Icon.vue";

interface AudioPlayerProps {
  playPauseRecording: () => Promise<void>;
  displayTime: string;
  containerId: string;
  isShown: boolean;
  icon: IconType;
  isMine: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AudioPlayer',
  props: {
    playPauseRecording: { type: Function },
    displayTime: {},
    containerId: {},
    isShown: { type: Boolean },
    icon: {},
    isMine: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "audio-player-icon-wrapper",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.playPauseRecording && _ctx.playPauseRecording(...args)))
      }, [
        _createVNode(Icon, {
          icon: _ctx.icon,
          alt: "pause icon"
        }, null, 8, ["icon"])
      ]),
      _createElementVNode("div", {
        id: _ctx.containerId,
        class: "player"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("span", {
      class: _normalizeClass(["playing-time", {
        isMine: _ctx.isMine,
      }])
    }, _toDisplayString(_ctx.displayTime), 3)
  ]))
}
}

})